var ResultCountSummary = React.createClass({
  propTypes: {
    totalHits: React.PropTypes.number.isRequired,
    pageStart: React.PropTypes.number,
    pageEnd: React.PropTypes.number,
    resultName: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      pageStart: 0,
      pageEnd: 0,
    }
  },
  getRange() {
    return <span><strong>{this.props.pageStart}-{this.props.pageEnd}</strong> {Labels.getLabel("of")} </span>;
  },
  render() {
    let {resultName, totalHits, pageStart, pageEnd} = this.props;
    let showRange = pageStart > 0 && pageEnd > 0 && !(pageStart == 1 && pageEnd == totalHits);
    resultName = resultName ? resultName : totalHits == 1 ? Labels.getLabel("result") : Labels.getLabel("results");

    return (
      <div className="result-col__counts" tabIndex="0">
        {`${Labels.getLabel("Showing")}`} {showRange ? this.getRange() : ""} <strong>{totalHits}</strong> {resultName}
      </div>
    )
  }
});